<template>
  <footer class="ibcgp-footer">
    <div class="footer-main ibcgp-footer-inner">
      <div class="container">
        <div class="row align-items-start">
          <div class="col-lg-2 col-md-4 col-6 mb-3 mb-lg-0">
            <a
              :href="base"
              class="d-inline-block"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="ibcgp-footer-logo"
                src="@/assets/images/ibcgp/logo-branca.png"
                alt="IBCGP"
              >
            </a>
          </div>

          <div class="col-lg-3 col-md-8 col-6 mb-3 mb-lg-0">
            <h6 class="ibcgp-footer-title">Contato</h6>
            <ul class="ibcgp-footer-list list-unstyled">
              <li>
                <a href="tel:556730424800">+55 (67) 3042-4800</a>
              </li>
              <li>
                <a href="mailto:contato@ibcgp.org.br">contato@ibcgp.org.br</a>
              </li>
              <li class="small">
                <a
                  href="https://www.google.com/maps/place/Delta+Contabilidade+e+Assessoria/@-20.480555,-54.598586,14z/data=!4m5!3m4!1s0x0:0xa89e5bf31511351f!8m2!3d-20.4805591!4d-54.5986016?hl=pt-BR"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Rua Santana, 143 — Campo Grande/MS
                </a>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
            <h6 class="ibcgp-footer-title">Soluções</h6>
            <ul class="ibcgp-footer-list list-unstyled">
              <li>
                <a :href="`${base}/#solucoes`" target="_blank" rel="noopener noreferrer">Visão geral</a>
              </li>
              <li>
                <a :href="links.plataformaGestao" target="_blank" rel="noopener noreferrer">Gestão Rural</a>
              </li>
              <li>
                <a :href="links.concursosPublico" target="_blank" rel="noopener noreferrer">Portal de concursos</a>
              </li>
              <li>
                <a :href="links.cursosLanding" target="_blank" rel="noopener noreferrer">Cursos (vitrine)</a>
              </li>
              <!-- <li>
                <a :href="links.cursosPlataformaLogin" target="_blank" rel="noopener noreferrer">Área do aluno</a>
              </li> -->
            </ul>
          </div>

          <div class="col-lg-4 col-md-6">
            <h6 class="ibcgp-footer-title">Institucional</h6>
            <ul class="ibcgp-footer-list ibcgp-footer-list-inline-md list-unstyled">
              <li><a :href="base" target="_blank" rel="noopener noreferrer">Início</a></li>
              <li><a :href="`${base}/sobre`" target="_blank" rel="noopener noreferrer">O Instituto</a></li>
              <li><a :href="`${base}/concursos`" target="_blank" rel="noopener noreferrer">Publicações Concursos</a></li>
              <li><a :href="`${base}/publicacoes`" target="_blank" rel="noopener noreferrer">Publicações</a></li>
              <li><a :href="`${base}/contato`" target="_blank" rel="noopener noreferrer">Contato</a></li>
            </ul>
            <a
              class="ibcgp-footer-insta mt-2 d-inline-flex align-items-center"
              :href="links.instagram"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram IBCGP"
            >
              <i class="fab fa-instagram" aria-hidden="true" />
              <span class="ml-1">@ibcgp</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom-bar text-center py-2">
      <small class="mb-0 d-block ibcgp-footer-copy">
        © {{ year }}
        <a :href="base" class="ibcgp-footer-copy-link" target="_blank" rel="noopener noreferrer">IBCGP</a>
        — Todos os direitos reservados
        <span class="ibcgp-footer-version ml-1">· v.{{ pkg.version }}</span>
      </small>
    </div>
  </footer>
</template>

<script>
import pkg from '../../package.json'
import links from '@/consts/links.js'

export default {
  name: 'FooterComp',

  data () {
    return {
      pkg,
      links
    }
  },

  computed: {
    base () {
      return this.links.siteInstitucional.replace(/\/$/, '')
    },
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>
